import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Modal,
  Box,
  Grid,
  TextField,
  Autocomplete,
  IconButton,
  CircularProgress,
  Stack,
  Typography,
} from "@mui/material";
import toast, { Toaster } from "react-hot-toast";
import CloseIcon from "@mui/icons-material/Close";
import activeIcon from "../../../Assests/activeIcon.svg";
import inactiveIcon from "../../../Assests/inactiveIcon.svg";
import editIcon from "../../../Assests/editIcon.svg";
import deleteIcon from "../../../Assests/deleteIcon.svg";
import React, { useEffect, useState } from "react";
import { FaEdit } from "react-icons/fa";
import CustomerInfoModal from "./CustomerInfoModal";
import HeaderNavigation from "../../../Componants/Common/header Navigation/HeaderNavigation";
import CommonButton from "../../../Componants/Common/Button";
import CustomDatePicker from "../../../Componants/Common/Custom Date Picker/CustomDatePicker";
import DynamicTabs from "../../../components/DynamicTabs";
import { useNavigate } from "react-router-dom";
import { Calendar } from "../../../Componants/Common/Calender";
import {
  dropdownSubscription,
  fetchSubscriptionList,
  getOrganizations,
  upgradeToSubscription,
} from "../../../API Service/apiService";
import Loader from "../../../Componants/Loader/Loader";
// import { Link, useNavigate } from "react-router-dom";

import infoIcon from "../../../Assests/infoIcon.svg";
import SubscriptionModal from "./SubscriptionModal";
import dayjs from "dayjs";
import Paginate from "../../../Componants/Common/Paginate";
import { Constants } from "../../../constants/Constants";
import { formatDate, formatDateForPayload, validateDateRange, parseDateInput } from "../../../utils/dateFormatter";
// const style = {
//   position: "absolute",
//   top: "50%",
//   left: "50%",
//   transform: "translate(-50%, -50%)",
//   width: 400,
//   bgcolor: "background.paper",
//   border: "2px solid #000",
//   boxShadow: 24,
//   pt: 2,
//   px: 4,
//   pb: 3,
// };

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "calc(60% - 20px)",
  maxHeight: "90vh",
  overflowY: "auto",
  bgcolor: "#EFF3FE",
  boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)",
  border: "none !important",
  borderRadius: "12px",
  p: 4,
};

const tableStyles = {
  table: {
    minWidth: 650,
    "& .MuiTableCell-root": {
      padding: "12px 16px",
    },
  },
  tableHead: {
    "& .MuiTableCell-head": {
      backgroundColor: "#32499F",
      color: "white",
      fontWeight: 600,
      textAlign: "center",
    },
  },
  tableRow: {
    "&:nth-of-type(odd)": {
      backgroundColor: "#f5f8ff",
    },
    "&:hover": {
      backgroundColor: "#e8eeff",
    },
  },
  actionButton: {
    backgroundColor: "#32499F",
    color: "white",
    "&:hover": {
      backgroundColor: "#253a7d",
    },
  },
};

const cells1 = [
  "Client Name",
  "Company Name",
  "Subscription Plan",
  "Subscription Start ",
  "Subscription Ends ",
  "No. of Licenses",
  "Plan Price",
  "Payment Due Date",
  "Status",
  "Action",
];
const cells2 = [
  "Client Name",
  "Company Name",
  "Subscription Plan",
  "Trial Start",
  "Trial End",
  "No. of Licenses",
  // "Payment Due Date",
  "Status",
  "Action",
];

const rows = [
  {
    clientName: "ABC Corp",
    subscriptionPlan: "Enterprise",
    subscribedOn: "2023-01-15",
    subscriptionEndsOn: "2024-01-14",
    licenses: 50,
    paymentDue: "2024-01-10",
    status: "Active",
  },
  {
    clientName: "XYZ Pvt Ltd",
    subscriptionPlan: "Pro Plan",
    subscribedOn: "2023-06-01",
    subscriptionEndsOn: "2024-06-01",
    licenses: 20,
    paymentDue: "2023-12-15",
    status: "Active",
  },
  {
    clientName: "Global Ventures",
    subscriptionPlan: "Basic Plan",
    subscribedOn: "2022-09-20",
    subscriptionEndsOn: "2023-09-19",
    licenses: 10,
    paymentDue: "2023-09-10",
    status: "Inactive",
  },
  {
    clientName: "Tech Solutions",
    subscriptionPlan: "Enterprise",
    subscribedOn: "2023-03-12",
    subscriptionEndsOn: "2024-03-11",
    licenses: 100,
    paymentDue: "2024-03-01",
    status: "Active",
  },
];

const subscriptionTypeOptions = [
  { label: "Subscription", value: "subscription" },
  { label: "Trial", value: "trial" },
];
const statusOptions = [
  { label: "Active", value: "active" },
  { label: "Inactive", value: "inactive" },
];

const CreateOrganizationsView = () => {
  const [subscriptionType, setSubscriptionType] = useState("subscription");
  const [open, setOpen] = useState(false);
  const [dataSize, setDataSize] = useState(10);
  const [page, setPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(1);
  const navigate = useNavigate();
  const [startDate, setStartDate] = useState(dayjs());
  const [endDate, setEndDate] = useState(dayjs().add(1, "month"));
  const [planParams, setPlanParams] = useState({
    organizationId: "",
    noOfLicense: "",
    planPrice: "",
    subscriptionPlanId: "",
    startDate: "",
    endDate: "",
  });

  const [organizations, setOrganizations] = useState([]); // Store API data
  const [filters, setFilters] = useState({
    search: "",
    subscriptionType: "subscription",
    status: "",
    mobileNo: "",
    email: "",
    paymentDueFrom: null,
    paymentDueTo: null,
    organizationId: "",
    page: 1,
    limit: 10,
  });
  const [updateData, setUpdateData] = useState({
    organizationId: "",
    subscriptionType: "subscription",
    subscriptionPlan: "",
    subscriptionPlanId: "",
    noOfLicense: "",
    planPrice: "",
    startDate: null,
    endDate: null,
  })

  const [subscriptionPlan, setSubscriptionPlan] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [filterErrors, setFilterErrors] = useState({});
  const [modalErrors, setModalErrors] = useState({});
  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  const fetchOrganizations = async (params = {}) => {
    try {
      setLoading(true);
      const formattedParams = {
        ...params,
        paymentDueFrom: formatDateForPayload(params.paymentDueFrom, ""),
        paymentDueTo: formatDateForPayload(params.paymentDueTo, ""),
      };
      const data = await getOrganizations({
        ...formattedParams,
        page: page,
        limit: dataSize,
      });
      if(data?.status == "success"|| data?.status == 200){
        setOrganizations(data?.data?.organizations || []);
        setTotalRecords(data?.data?.pagination.totalRecords || 0); // Make sure your API returns total count
      }else{
        toast.error(data.message);
        setOrganizations([]);
        setTotalRecords(0);
      }
    } catch (err) {
      console.log("error====>", err.message);
      setError(err.message);
      toast.error(err.message||"No Data Found");
      setOrganizations([]);
      setTotalRecords(0);
    } finally {
      setLoading(false);
    }
  };
  // Load data initially

  // Handle search input changes
  const handleChange = (event) => {
    const { name, value } = event.target;
    setFilters((prevFilters) => ({
      ...prevFilters,
      [name]: value,
    }));
  };

  // Handle dropdown selection

  const handleDropdownChange = (event, value, field) => {
    if (field === "status") {
      setFilters((prev) => ({
        ...prev,
        status: value === null ? "" : value.value, // Handle null case when clearing selection
      }));
    } else {
      setFilters((prev) => ({
        ...prev,
        [field]: value?.value || value?.label || "",
      }));
    }
  };
  // Handle Search
  const handleSearch = () => {
    // Prevent search if there are validation errors (e.g., date range issues)
    if (Object.values(filterErrors).some((error) => error)) {
      // toast.error("Please resolve validation errors before searching");
      return;
    }
    setPage(1);
    fetchOrganizations(filters);
  };

  // Handle Reset (Cancel Button)
  const handleReset = () => {
    setPage(1);
    setFilterErrors({});
    setFilters({
      search: "",
      subscriptionType: "subscription",
      status: "",
      mobileNo: "",
      email: "",
      paymentDueFrom: null,
      paymentDueTo: null,
    });
    fetchOrganizations({
      search: "",
      subscriptionType: "subscription",
      status: "",
      mobileNo: "",
      email: "",
      paymentDueFrom: null,
      paymentDueTo: null,
      page: 1,
      limit: dataSize
    });
  };

  const handleOpen = (org) => {
    setUpdateData({
      organizationId: org._id,
      subscriptionType: "subscription",
      subscriptionPlan: org.subscriptionPlan || "",
      subscriptionPlanId: org.subscriptionPlanId || "",
      noOfLicense: org.noOfLicense || "",
      planPrice: org.planPrice || "",
      startDate: null,
      endDate: null,
    });
    setOpen(true);
  };

  const getSubscriptionPlan = async () => {
    try {
      setLoading(true);
      const data = await fetchSubscriptionList();
      console.log(data);
      setSubscriptionPlan(data || []);
    } catch (err) {
      setError("Failed to fetch subscription plan.");
      toast.error("Failed to fetch subscription plan.");
      // console.log("error====>", err);
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setOpen(false);
    setModalErrors({});
  };
  // Generic handler for updating form fields
  const handleDateChange = (fieldName, value) => {
    setFilters((prev) => {
      const updatedFilters = { ...prev, [fieldName]: value };

      // Instant validation for dates using common function
      if (fieldName === "paymentDueFrom" || fieldName === "paymentDueTo") {
        const validation = validateDateRange(updatedFilters.paymentDueFrom, updatedFilters.paymentDueTo);
        setFilterErrors((prevErrors) => ({
          ...prevErrors,
          paymentDueTo: validation.error,
        }));
      }
      return updatedFilters;
    });
    setFilterErrors((prev) => ({ ...prev, [fieldName]: "" }));
  };

  const handleModalDateChange = (fieldName, value) => {
    const formattedDate = formatDateForPayload(value);
    setUpdateData((prev) => {
      const updatedData = { ...prev, [fieldName]: formattedDate };

      if (fieldName === "startDate" || fieldName === "endDate") {
        const validation = validateDateRange(updatedData.startDate, updatedData.endDate);
        setModalErrors((prevErrors) => ({
          ...prevErrors,
          endDate: validation.error,
        }));
      }
      return updatedData;
    });
    setModalErrors((prev) => ({ ...prev, [fieldName]: "" }));
  };

  // Add handleEdit function
  const handleEdit = (orgId) => {
    if (!orgId) {
      toast.error("Organization ID is required for editing");
      return;
    }
    navigate(`/createorganizations?orgID=${orgId}`);
  };
  const handleModalReset = () => {
    setUpdateData((prev) => ({
      ...prev,
      subscriptionPlan: "",
      subscriptionPlanId: "",
      noOfLicense: "",
      planPrice: "",
      startDate: null,
      endDate: null,
    }));
    setModalErrors({});
  };

  const handleUpgradeSubmit = async () => {
    if (Object.values(modalErrors).some(err => err)) {
      // toast.error("Please resolve validation errors");
      return;
    }
    if (!updateData.organizationId || !updateData.subscriptionPlanId || !updateData.startDate || !updateData.endDate || !updateData.noOfLicense || !updateData.planPrice) {
      toast.error("Please fill all required fields");
      return;
    }

    try {
      setLoading(true);
      const payload = {
        organizationId: updateData.organizationId,
        noOfLicense: parseInt(updateData.noOfLicense),
        planPrice: parseFloat(updateData.planPrice),
        subscriptionPlanId: updateData.subscriptionPlanId,
        startDate: formatDateForPayload(updateData.startDate),
        endDate: formatDateForPayload(updateData.endDate),
      };

      const response = await upgradeToSubscription(payload);
      if (response.status === "success" || response.status === 200) {
        toast.success(response.message || "Organization upgraded to Subscription successfully!");
        handleClose();
        fetchOrganizations(filters);
      } else {
        toast.error(response.message || "Failed to upgrade");
      }
    } catch (err) {
      console.error("Upgrade error:", err);
      toast.error(err.response?.data?.message || err.message || "An error occurred during upgrade");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getSubscriptionPlan();
  }, []);
  useEffect(() => {
    setPage(1);
  }, [filters]);
  useEffect(() => {
    fetchOrganizations(filters);
  }, [page, filters.subscriptionType]);

  return (
    <Grid container>
      <HeaderNavigation value={"Client Organization"} />
      <DynamicTabs />

      <Grid
        container
        sx={{
          background: "#EFF3FE",
          margin: "10px",
          width: "calc(100% - 20px)",
          borderRadius: "12px",
          padding: "20px",
          boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.05)",
        }}
      >
        {" "}
        <Grid container justifyContent={"flex-end"}></Grid>
        <Grid container gap={5}>
          <Grid item>
            <Autocomplete
              id="disable-close-on-select"
              options={subscriptionTypeOptions}
              getOptionLabel={(option) => option.label}
              value={subscriptionTypeOptions.find(opt => opt.value === filters.subscriptionType) || null}
              onChange={(event, value) =>
                handleDropdownChange(event, value, "subscriptionType")
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Subscription Type"
                  variant="standard"
                  style={{ width: "12rem" }}
                />
              )}
            />
          </Grid>
          <Grid item>
            <TextField
              style={{ width: "100%" }}
              id="customer-name"
              label="Customer Name"
              variant="standard"
              name="search" // Ensure this matches state key
              value={filters.search}
              onChange={handleChange}
            />
          </Grid>
          <Grid item>
            <TextField
              style={{ width: "100%" }}
              id="customer-email"
              label="Customer Email"
              variant="standard"
              name="email" // Ensure this matches state key
              value={filters.email}
              onChange={handleChange}
            />
          </Grid>
          <Grid item>
            <TextField
              style={{ width: "100%" }}
              id="customer-mobile"
              label="Customer Mobile No."
              variant="standard"
              name="mobileNo" // Ensure this matches state key
              value={filters.mobileNo}
              onChange={handleChange}
            />
          </Grid>

          <Grid container gap={3}>
            {filters.subscriptionType === "subscription" && (
              <>
                <Grid item>
                  {/* <CustomDatePicker label={"Payment Due From"} width={"90%"} /> */}
                  <Calendar
                    value={filters.paymentDueFrom}
                    handleChange={handleDateChange}
                    fieldName="paymentDueFrom"
                    label="Payment Due From"
                    withPortal={true}
                    error={!!filterErrors.paymentDueFrom}
                    helperText={filterErrors.paymentDueFrom}
                  />
                </Grid>

                <Grid item>
                  {/* <CustomDatePicker label={"Payment Due To"} width={"90%"} /> */}
                  <Calendar
                    value={filters.paymentDueTo}
                    handleChange={handleDateChange}
                    fieldName="paymentDueTo"
                    label="Payment Due To"
                    withPortal={true}
                    error={!!filterErrors.paymentDueTo}
                    helperText={filterErrors.paymentDueTo}
                    minDate={filters.paymentDueFrom}
                  />
                </Grid>
              </>
            )}

            <Grid item>
              <Autocomplete
                id="disable-close-on-select"
                options={statusOptions}
                getOptionLabel={(option) => option.label}
                value={
                  statusOptions.find(
                    (option) => option.value === filters.status
                  ) || null
                }
                onChange={(event, value) =>
                  handleDropdownChange(event, value, "status")
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Status"
                    variant="standard"
                    style={{ width: "12rem" }}
                  />
                )}
              />
            </Grid>
            <CommonButton
              name={Constants.search}
              handleOnClick={handleSearch}
            />
            <CommonButton name={Constants.cancel} handleOnClick={handleReset} />
            <CommonButton
              name={"Create New Organization"}
              handleOnClick={() => navigate("/createorganizations")}
            />
          </Grid>
        </Grid>
      </Grid>

      <Grid
        container
        mt={5}
        sx={{
          background: "#EFF3FE",
          margin: "10px",
          width: "calc(100% - 20px)",
          borderRadius: "12px",
          padding: "20px",
          boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.05)",
        }}
      >
        {filters.subscriptionType == "subscription" && (
          <div>
            <h3>Subscription Table</h3>
            <TableContainer component={Paper} sx={{ width: "100%" }}>
              <Table
                sx={{
                  width: "100%",
                  minWidth: 650,
                  tableLayout: "fixed", // This helps with consistent column widths
                }}
                size="small"
                aria-label="simple table"
              >
                <TableHead>
                  <TableRow>
                    {cells1.map((cell, index) => (
                      <TableCell
                        key={index}
                        sx={{
                          color: "white",
                          textAlign: "center",
                          // whiteSpace: "nowrap",
                          width: `${100 / cells1.length}%`, // Evenly distribute column widths
                        }}
                      >
                        {cell}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {loading ? (
                    <TableRow>
                      <TableCell colSpan={7} align="center">
                        Loading...
                      </TableCell>
                    </TableRow>
                  ) : organizations.length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={7} align="center">
                        No records found
                      </TableCell>
                    </TableRow>
                  ) : (
                    organizations.map((org, index) => (
                      <TableRow key={index}>
                        <TableCell align="center">{org.clientName}</TableCell>
                        <TableCell align="center">
                          {org.companyName || "N/A"}
                        </TableCell>
                        <TableCell align="center">
                          {org.subscriptionType || "N/A"}
                        </TableCell>
                        <TableCell align="center" sx={{ whiteSpace: "nowrap" }}>
                          {formatDate(org?.subscriptionStartDate)}
                        </TableCell>
                        <TableCell align="center" sx={{ whiteSpace: "nowrap" }}>
                          {formatDate(org?.subscriptionEndDate)}
                        </TableCell>
                        <TableCell align="center">
                          {org.noOfLicense || "N/A"}
                        </TableCell>
                        <TableCell align="center">
                          {org.finalPricePlan || "N/A"}
                        </TableCell>
                        <TableCell align="center" sx={{ whiteSpace: "nowrap" }}>
                          {formatDate(org.paymentDueDate) || "N/A"}
                        </TableCell>
                        <TableCell align="center">
                          <img
                            src={
                              org.subscriptionStatus ? activeIcon : inactiveIcon
                            }
                            alt="Status"
                            height="20px"
                            width="20px"
                          />
                        </TableCell>
                        <TableCell align="center">
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              gap: 1,
                              width: "100%",
                            }}
                          >
                            <IconButton
                              onClick={() => handleEdit(org._id)}
                              sx={{
                                outline: "none",
                                "&:focus": { outline: "none" },
                                padding: 0,
                              }}
                            >
                              <img
                                src={editIcon}
                                alt="Edit"
                                height="20px"
                                width="20px"
                              />
                            </IconButton>

                            <SubscriptionModal
                              open={open}
                              handleClose={handleClose}
                            />
                          </Box>
                        </TableCell>
                      </TableRow>
                    ))
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        )}
        {filters.subscriptionType == "trial" && (
          <div>
            <h3>Trial Table</h3>
            <TableContainer component={Paper} sx={{ width: "100%" }}>
              <Table
                sx={{
                  width: "100%",
                  minWidth: 650,
                  tableLayout: "fixed",
                }}
                size="small"
                aria-label="simple table"
              >
                <TableHead>
                  <TableRow>
                    {cells2.map((cell, index) => {
                      const widths = ["12%", "12%", "12%", "10%", "10%", "10%", "6%", "14%"];
                      return (
                        <TableCell
                          key={index}
                          sx={{
                            color: "white",
                            textAlign: "center",
                            width: widths[index],
                          }}
                        >
                          {cell}
                        </TableCell>
                      );
                    })}
                  </TableRow>
                </TableHead>

                <TableBody>
                  {loading ? (
                    <TableRow>
                      <TableCell colSpan={7} align="center">
                        Loading...
                      </TableCell>
                    </TableRow>
                  ) : organizations.length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={7} align="center">
                        No records found
                      </TableCell>
                    </TableRow>
                  ) : (
                    organizations.map((org, index) => (
                      <TableRow key={index}>
                        <TableCell align="center" sx={{ width: "12%" }}>{org.clientName}</TableCell>
                        <TableCell align="center" sx={{ width: "12%" }}>
                          {org.companyName || "N/A"}
                        </TableCell>
                        <TableCell align="center" sx={{ width: "12%" }}>
                          {org.subscriptionType || "N/A"}
                        </TableCell>

                        <TableCell align="center" sx={{ whiteSpace: "nowrap", width: "10%" }}>
                          {formatDate(org?.trialStartDate) || "NA"}
                        </TableCell>
                        <TableCell align="center" sx={{ whiteSpace: "nowrap", width: "10%" }}>
                          {formatDate(org?.trialEndDate) || "NA"}
                        </TableCell>
                        <TableCell align="center" sx={{ width: "10%" }}>
                          {org.noOfLicense || "N/A"}
                        </TableCell>
                        {/* <TableCell align="center" sx={{ width: "12%" }}>
                          {org.paymentDueDate || "N/A"}
                        </TableCell> */}
                        <TableCell align="center" sx={{ width: "6%" }}>
                          <img
                            src={org.trialStatus ? activeIcon : inactiveIcon}
                            alt="Status"
                            height="20px"
                            width="20px"
                          />
                        </TableCell>
                        <TableCell align="center" sx={{ width: "14%" }}>
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              gap: 1,
                              width: "100%",
                            }}
                          >
                            <IconButton
                              onClick={() => handleEdit(org._id)}
                              sx={{
                                outline: "none",
                                "&:focus": { outline: "none" },
                                padding: 0,
                              }}
                            >
                              <img
                                src={editIcon}
                                alt="Edit"
                                height="20px"
                                width="20px"
                              />
                            </IconButton>
                            <CommonButton
                              name="Upgrade"
                              handleOnClick={() => handleOpen(org)}
                            />

                            <SubscriptionModal
                              open={open}
                              handleClose={handleClose}
                            />
                          </Box>
                        </TableCell>
                      </TableRow>
                    ))
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        )}
      </Grid>
      <Grid
        contianer
        sx={{
          width: "100%",
        }}
      >
        <Paginate
          page={page}
          totalRecords={totalRecords}
          onPageChange={handlePageChange}
          dataSize={dataSize}
        />
      </Grid>
      <Modal
        open={open}
        onClose={(event, reason) => {
          if (reason !== "backdropClick") {
            handleClose();
          }
        }}
        aria-labelledby="subscription-modal"
        sx={{
          "& .MuiBackdrop-root": {
            backgroundColor: "rgba(0, 0, 0, 0.5)", // Darken slightly to focus on modal
          },
        }}
      >
        <Box sx={{ ...style, position: "relative" }}>
          <IconButton
            onClick={handleClose}
            sx={{
              position: "absolute",
              top: 8,
              right: 8,
              color: (theme) => theme.palette.grey[500],
              "&:focus": { outline: "none" },
            }}
          >
            <CloseIcon />
          </IconButton>
          <Typography variant="h6" component="h2" sx={{ mb: 4 }}>
            Upgrade Subscription
          </Typography>

          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <Autocomplete
                options={subscriptionTypeOptions.filter(opt => opt.value === "subscription")}
                getOptionLabel={(option) => option.label}
                value={subscriptionTypeOptions.find(opt => opt.value === "subscription") || null}
                // value={
                //   subscriptionTypeOptions.find(
                //     (option) => option.value === updateData.subscriptionType
                //   ) || null
                // }
                // onChange={(event, newValue) => {
                //   setUpdateData({
                //     ...updateData,
                //     subscriptionType: newValue ? newValue.value : "",
                //   });
                // }}
                // isOptionEqualToValue={(option, value) => option.value === value.value}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Subscription Type"
                    fullWidth
                    variant="standard"
                  />
                )}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <Calendar
                value={parseDateInput(updateData.startDate)}
                handleChange={handleModalDateChange}
                fieldName="startDate"
                label="Start Date"
                withPortal={true}
                minDate={new Date()}
                error={!!modalErrors.startDate}
                helperText={modalErrors.startDate}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <Autocomplete
                options={subscriptionPlan}
                getOptionLabel={(option) => option.packageName || ""}
                value={subscriptionPlan.find((option) => option._id === updateData.subscriptionPlanId) || null}
                onChange={(event, newValue) => {
                  setUpdateData({
                    ...updateData,
                    subscriptionPlan: newValue ? newValue.packageName : "",
                    subscriptionPlanId: newValue ? newValue._id : "",
                  });
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Subscription Plan"
                    fullWidth
                    variant="standard"
                  />
                )}
                disabled={updateData.subscriptionType === "trial"}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <Calendar
                value={parseDateInput(updateData.endDate)}
                handleChange={handleModalDateChange}
                fieldName="endDate"
                label="End Date"
                withPortal={true}
                minDate={parseDateInput(updateData.startDate) || new Date()}
                error={!!modalErrors.endDate}
                helperText={modalErrors.endDate}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="No. of Licenses"
                type="number"
                variant="standard"
                InputProps={{
                  inputProps: { min: 1 },
                }}
                value={updateData.noOfLicense}
                onChange={(e) => setUpdateData({ ...updateData, noOfLicense: e.target.value })}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Plan Price"
                type="number"
                variant="standard"
                InputProps={{
                  startAdornment: "₹",
                  inputProps: { min: 0 },
                }}
                value={updateData.planPrice}
                onChange={(e) => setUpdateData({ ...updateData, planPrice: e.target.value })}
              />
            </Grid>
          </Grid>

          <Stack
            direction="row"
            spacing={2}
            justifyContent="flex-end"
            sx={{ mt: 4 }}
          >
            <CommonButton name={"Upgrade"} handleOnClick={handleUpgradeSubmit} />
            <CommonButton name={"Cancel"} handleOnClick={handleModalReset} />
          </Stack>
        </Box>
      </Modal>

      <Toaster />
      {loading && <Loader />}
    </Grid>
  );
};

export default CreateOrganizationsView;
